module.exports = __webpack_public_path__ + "static/media/Original Korean Excerpt from Guide - Charity.27ea79d8.pdf";